import { ModalAction } from './actions';
import { ModalType } from './models';

export type ModalStore = {
  pullRequestUUID?: string;
  showModalType?: ModalType;
};

export const modalInitialState = {};

export const store = (
  state: ModalStore = {},
  action: ModalAction
): ModalStore => {
  switch (action.type) {
    case 'REVIEWS/MODALS/CLEAR_REVIEW_MODAL':
      return {};
    case 'REVIEWS/MODALS/SHOW_REVIEW_MODAL':
      const { pullRequestUUID, modalType } = action;
      return {
        pullRequestUUID,
        showModalType: modalType,
      };
    default:
      return state;
  }
};
